import { render, staticRenderFns } from "./AddOrUpdateCanteenIndexConfig.vue?vue&type=template&id=447d681e&scoped=true&"
import script from "./AddOrUpdateCanteenIndexConfig.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateCanteenIndexConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d681e",
  null
  
)

export default component.exports